import noActivityMarkEn from "../../assets/audio/mark_noactivity_en.mp3";
import noActivityMarkId from "../../assets/audio/mark_noactivity_id.mp3";
import noActivityJoeieEn from "../../assets/audio/joeie_noactivity_en.mp3";
import noActivityJoeieId from "../../assets/audio/joeie_noactivity_id.mp3";
import noActivityDilaEn from "../../assets/audio/dila_noactivity_en.mp3";
import noActivityDilaId from "../../assets/audio/dila_noactivity_id.mp3";
import noActivityHannaEn from "../../assets/audio/hanna_noactivity_en.mp3";

const getAudioConfig = () => {
  const pathSegments = window.location.pathname.split("/");
  const avatar = pathSegments[pathSegments.length - 1];
  const language = sessionStorage.getItem("language") || "English";

  let audioFile;

  if (avatar === "Mark") {
    audioFile =
      language === "English"
        ? noActivityMarkEn
        : language === "Indonesia"
        ? noActivityMarkId
        : null;
  } else if (avatar === "Joeie") {
    audioFile =
      language === "English"
        ? noActivityJoeieEn
        : language === "Indonesia"
        ? noActivityJoeieId
        : null;
  } else if (avatar === "Dila" || avatar === "Dilla") {
    audioFile =
      language === "English"
        ? noActivityDilaEn
        : language === "Indonesia"
        ? noActivityDilaId
        : null;
  } else if (avatar === "Hanna") {
    audioFile = language === "English" ? noActivityHannaEn : null;
  } else {
    console.error("Unknown avatar:", avatar);
  }

  if (!audioFile) {
    console.error(
      "Audio file not found for avatar:",
      avatar,
      "and language:",
      language
    );
  }

  return audioFile;
};

export default getAudioConfig;
